<template>
  <!-- メインコンテンツエリア -->
  <main class="l-main">
    <div class="l-main-content">
      <div class="p-login">
        <!-- ロゴ -->
        <login-logo />
        <!-- /ロゴ -->
        <terms-form :content="content" />
        <!-- コピーライト -->
        <login-copyright />
        <!-- /コピーライト -->
      </div>
    </div>
  </main>
<!-- /メインコンテンツエリア -->
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  mounted: function () {
    import('../../funcs/pages/login-terms').then(module => {
      module.LoginTerms();
    });
  },
}
</script>
